import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import Header from "../Components/header";
import Sidebar from "../Components/sidebar";
import { useParams, Link, Navigate, useLocation } from "react-router-dom";
import { GraphQLClient } from "graphql-request";
import Footer from "../Components/footer";
import NotFound from "./notFound";
import { RichText } from "@graphcms/rich-text-react-renderer";
import { addToCart } from "./api";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Editor } from "@tinymce/tinymce-react";
import { AiOutlineCheckCircle, AiOutlineEdit } from "react-icons/ai"; // Import the icon
import { CiCircleAlert } from "react-icons/ci";
import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  useQuery,
  useMutation,
  gql,
} from "@apollo/client";
import { FcDataProtection } from "react-icons/fc";
import { parse } from "html-to-ast";
import { BiBold } from "react-icons/bi";
import DragDrop from "../Components/drag_and_drop_upload";
import he from "he";

//const API_KEY =  "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6ImdjbXMtbWFpbi1wcm9kdWN0aW9uIn0.eyJ2ZXJzaW9uIjozLCJpYXQiOjE3MTYxOTQ4MDEsImF1ZCI6WyJodHRwczovL2FwaS1ldS1jZW50cmFsLTEtc2hhcmVkLWV1YzEtMDIuaHlncmFwaC5jb20vdjIvY2x3ZXEybTZhMDAwMDAxdzY3YXF6ZWg3eC9tYXN0ZXIiLCJtYW5hZ2VtZW50LW5leHQuZ3JhcGhjbXMuY29tIl0sImlzcyI6Imh0dHBzOi8vbWFuYWdlbWVudC1ldS1jZW50cmFsLTEtc2hhcmVkLWV1YzEtMDIuaHlncmFwaC5jb20vIiwic3ViIjoiZWYwZWJjYjEtM2IwNi00NjQ2LWFiNTItMWQwMmVlMzJmNzZmIiwianRpIjoiY2tsdXpicmxwNW9sOTAxeHY3MzI1OHRqZCJ9.j6_FyV0D25iUBrQB5EgA_e0IM-ABoTBW8E2lst5jNpC7jpkoefd98lxsIArNC4aM6E5_9MDUDF3aBZpE2vhQv8L0MXwwehcg4cyRJgZ8Ve9tTzLH5ZmZnMdN9L2EsuNxoZ9KHb50VT3-6sBHphWuXun-ufIQovt3p_WG_Fbs6X9exukEHW46y2B0YGM6D-h49g3PWg4YIcPcKoU2AOzk4LHFewzKzqvkaekAj0SZXxTIfqhpfvjafqhDKVUjTqcpo9TrGXuR7Mj8t0skdQg-p9LEHQ6StY3OjRS7iZt9EuQg21iG1A6--_m7PniC70kx494Y_CjsQvaEb3noHgav0XT5qRDVX_sru1zPLG12e-xcMPIceIej40E9oyN4HXETQn9I5zuDj7o6Fnqa8anIaf21C52qVEfD7XTOjC9ug9RwEb5Ix2r404SMNL8V5pKn81WsDE3tziYvfqm3nEf9NYSWASsVsidr_SGUFt6oGJIFF_D25jQtpnwjLpWytN7KrsG8T3t6SHa1rtGh2wf9WEaetA6qARUBJawgZD6TPNUTj7vflkzwNYFFM4dHNpaJj-tBUcTOcsutd_FLSLu5zLkbkFlDdyTUasSZGM_pZqeREHdpvKL8OZbIVSjt_NzxQp2aF3mHyQafE5PuZtjnlZBLkzmTUMa8Rf8FKtIKdIU"; // Sostituisci con la tua API key
const API_KEY = process.env.REACT_APP_HYGRAPH_MUTATION_TOKEN;
const client = new ApolloClient({
  uri: "https://eu-central-1-shared-euc1-02.cdn.hygraph.com/content/clweq2m6a000001w67aqzeh7x/master",
  //uri: "https://management-eu-central-1-shared-euc1-02.hygraph.com/graphql",
  cache: new InMemoryCache(),
  fetchPolicy: "network-only",
  headers: {
    Authorization: `Bearer ${API_KEY}`,
  },
});

const GET_PRODUCT_DATA = gql`
  query GetProductData($slug: String!) {
    rivistes(where: { slugRivista: $slug }, stage: DRAFT) {
      id
      stage
      numeroRivista
      dataPubblicazione
      prezzo
      slugRivista
      updatedAt
      publishedAt
      copertina {
        fileName
        url
      }
      sommario {
        raw
        html
      }
    }
  }
`;

const GET_PUBLISHED_PRODUCT = gql`
  query GetPublishedProduct($slug: String!) {
    rivistes(where: { slugRivista: $slug }, stage: PUBLISHED) {
      id
      stage
      updatedAt
      publishedAt
    }
  }
`;

const UPDATE_PRODUCT_PRICE = gql`
  mutation UpdateProductPrice(
    $id: ID!
    $prezzo: Float!
    $numeroRivista: String!
    $slug_rivista: String!
    $sommario: RichTextAST!
  ) {
    updateRiviste(
      where: { id: $id }
      data: {
        prezzo: $prezzo
        numeroRivista: $numeroRivista
        slugRivista: $slug_rivista
        sommario: $sommario
      }
    ) {
      id
      prezzo
      numeroRivista
      updatedAt
    }
  }
`;

const PUBLISH_PRODUCT = gql`
  mutation PublishProduct($id: ID!) {
    publishRiviste(where: { id: $id }) {
      id
      publishedAt
    }
  }
`;

// Definizione della mutazione per creare l'asset
const CREATE_ASSET = gql`
  mutation createAsset {
    createAsset(
      data: { fileName: "prova.jpg", handle: "prova2", mimeType: "image/jpeg" }
    ) {
      id
      url
      fileName
    }
  }
`;

const CREATE_RIVISTA = gql`
  mutation CreateRivista(
    $numeroRivista: String!
    $prezzo: Float!
    $slugRivista: String!
    $dataPubblicazione: Date!
    $copertinaId: ID!
    $sommario: RichTextAST!
  ) {
    createRiviste(
      data: {
        numeroRivista: $numeroRivista
        prezzo: $prezzo
        slugRivista: $slugRivista
        dataPubblicazione: $dataPubblicazione
        sommario: $sommario
        copertina: { connect: { id: $copertinaId } }
      }
    ) {
      id
    }
  }
`;

const PUBBLICA_RIVISTA = gql`
  mutation PublishRivista($idRivista: ID!) {
    publishRiviste(where: { id: $idRivista }, to: PUBLISHED) {
      id
    }
  }
`;

const UNPUBLISH_RIVISTA = gql`
  mutation UnpublishRivista($idRivista: ID!) {
    unpublishRiviste(where: { id: $idRivista }) {
      id
    }
  }
`;

const PUBBLICA_IMMAGINE = gql`
  mutation UNPUBLISH_RIVISTA($idRivista: ID!) {
    unpublishRiviste(where: { id: $idRivista }, to: DRAFT) {
      id
    }
  }
`;

function convertToHygraphRichText(ast) {
  const convertNode = (node) => {
    if (node.type === "tag") {
      if (node.name === "ul") {
        return {
          type: "bulleted-list",
          children: node.children
            .filter((child) => child.type === "tag" && child.name === "li")
            .map(convertNode),
        };
      } else if (node.name === "li") {
        return {
          type: "list-item",
          children: node.children.map(convertNode),
        };
      } else if (node.name === "div" || node.name === "p") {
        return {
          type: "paragraph",
          children: node.children.map(convertNode),
        };
      } else if (node.name === "strong") {
        return {
          type: "text",
          bold: true,
          text: node.children
            .map((child) =>
              child.type === "text" ? he.decode(child.content) : ""
            )
            .join(""),
        };
      } else if (node.name === "span") {
        return {
          type: "text",

          text: node.children
            .map((child) =>
              child.type === "text" ? he.decode(child.content) : ""
            )
            .join(""),
        };
      } else if (node.name === "sup") {
        // Gestione del tag <sup>
        return {
          type: "superscript",
          children: node.children.map(convertNode),
        };
      }
    } else if (node.type === "text") {
      const decodedText = he.decode(node.content);
      return { text: decodedText };
    }
    return null;
  };

  const result = ast.map(convertNode).flat(2).filter(Boolean); // Rimuove eventuali nodi null
  console.log(
    "Risultato convertito con lista e formattazione:",
    JSON.stringify(result, null, 2)
  );
  return { children: result };
}

export const NuovaRivistaProva = () => {
  const [message, setMessage] = useState("");
  const [file, setFile] = useState(null);
  const fileInputRef = useRef(null);
  const [previewImage, setPreviewImage] = useState(null);
  const editorRef = useRef(null);
  const [editorContent, setEditorContent] = useState("");
  const [formData, setFormData] = useState({
    numeroRivista: "",
    prezzo: 0,
    slug_rivista: "",
    sommario: "",
    dataPubblicazione: "",
  });

  useEffect(() => {
    console.log("FILE:", file);
  }, [file]);

  const [createRivista] = useMutation(CREATE_RIVISTA, {
    onError: (error) => {
      console.error("Errore nella mutazione createRivista:", error);
      setMessage("Errore durante la creazione della rivista.");
    },
  });

  const [pubblicaRivista] = useMutation(PUBBLICA_RIVISTA, {
    onError: (error) => {
      console.error("Errore nella mutazione publishRivista:", error);
      setMessage("Errore durante la pubblicazione della rivista.");
    },
  });

  const [pubblicaCopertina] = useMutation(PUBBLICA_IMMAGINE, {
    onError: (error) => {
      console.error("Errore nella mutazione publishRivista:", error);
      setMessage("Errore durante la pubblicazione della rivista.");
    },
  });

  async function handleUpload() {
    console.log("File per l'upload:", file);
    if (!file) {
      console.log("Nessun file selezionato.");
      setMessage("Nessun file selezionato.");
      return null;
    }

    try {
      const uploadData = new FormData();
      uploadData.append("fileUpload", file);

      console.log("1");

      const response = await fetch(
        `https://eu-central-1-shared-euc1-02.cdn.hygraph.com/content/clweq2m6a000001w67aqzeh7x/master`,
        {
          method: "POST",

          headers: {
            "Content-Type": "application/json",
            //Authorization: `Bearer ${API_KEY}`,
            Authorization: `Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6ImdjbXMtbWFpbi1wcm9kdWN0aW9uIn0.eyJ2ZXJzaW9uIjozLCJpYXQiOjE3MTYxOTQ4MDEsImF1ZCI6WyJodHRwczovL2FwaS1ldS1jZW50cmFsLTEtc2hhcmVkLWV1YzEtMDIuaHlncmFwaC5jb20vdjIvY2x3ZXEybTZhMDAwMDAxdzY3YXF6ZWg3eC9tYXN0ZXIiLCJtYW5hZ2VtZW50LW5leHQuZ3JhcGhjbXMuY29tIl0sImlzcyI6Imh0dHBzOi8vbWFuYWdlbWVudC1ldS1jZW50cmFsLTEtc2hhcmVkLWV1YzEtMDIuaHlncmFwaC5jb20vIiwic3ViIjoiZWYwZWJjYjEtM2IwNi00NjQ2LWFiNTItMWQwMmVlMzJmNzZmIiwianRpIjoiY2tsdXpicmxwNW9sOTAxeHY3MzI1OHRqZCJ9.j6_FyV0D25iUBrQB5EgA_e0IM-ABoTBW8E2lst5jNpC7jpkoefd98lxsIArNC4aM6E5_9MDUDF3aBZpE2vhQv8L0MXwwehcg4cyRJgZ8Ve9tTzLH5ZmZnMdN9L2EsuNxoZ9KHb50VT3-6sBHphWuXun-ufIQovt3p_WG_Fbs6X9exukEHW46y2B0YGM6D-h49g3PWg4YIcPcKoU2AOzk4LHFewzKzqvkaekAj0SZXxTIfqhpfvjafqhDKVUjTqcpo9TrGXuR7Mj8t0skdQg-p9LEHQ6StY3OjRS7iZt9EuQg21iG1A6--_m7PniC70kx494Y_CjsQvaEb3noHgav0XT5qRDVX_sru1zPLG12e-xcMPIceIej40E9oyN4HXETQn9I5zuDj7o6Fnqa8anIaf21C52qVEfD7XTOjC9ug9RwEb5Ix2r404SMNL8V5pKn81WsDE3tziYvfqm3nEf9NYSWASsVsidr_SGUFt6oGJIFF_D25jQtpnwjLpWytN7KrsG8T3t6SHa1rtGh2wf9WEaetA6qARUBJawgZD6TPNUTj7vflkzwNYFFM4dHNpaJj-tBUcTOcsutd_FLSLu5zLkbkFlDdyTUasSZGM_pZqeREHdpvKL8OZbIVSjt_NzxQp2aF3mHyQafE5PuZtjnlZBLkzmTUMa8Rf8FKtIKdIU`,
          },
          body: uploadData,
        }
      );

      console.log("2");

      if (!response.ok) {
        throw new Error("Errore durante il caricamento del file.");
      }

      console.log("3");
      const responseData = await response.json();
      const assetId = responseData.id;
      console.log("ID dell'asset caricato:", assetId);
      //alert(assetId);

      console.log("4");
      await pubblicaCopertina({
        variables: {
          idImage: assetId,
        },
      });
      console.log("IMMAGINE PUBBLICATA");

      return assetId; // Ritorna l'ID dell'asset per la mutazione
    } catch (error) {
      console.error("Errore durante il caricamento:", error);
      setMessage("Errore durante il caricamento dell'immagine.");
      throw error;
    }
  }

  /*
  function handleFileChange(event) {
    setFile(event.target.files[0]);
  }*/
  const handleFileChange = (file) => {
    //const file = event.target.files[0];

    if (file) {
      // Create a URL for the selected file
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(file);
      //setFile(event.target.files[0]);

      // Handle file upload or other logic here...
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  function convertToHygraphRichText(ast) {
    const convertNode = (node) => {
      if (node.type === "tag") {
        if (node.name === "ul") {
          return {
            type: "bulleted-list",
            children: node.children
              .filter((child) => child.type === "tag" && child.name === "li")
              .map(convertNode),
          };
        } else if (node.name === "li") {
          return {
            type: "list-item",
            children: node.children.map(convertNode),
          };
        } else if (node.name === "div" || node.name === "p") {
          return {
            type: "paragraph",
            children: node.children.map(convertNode),
          };
        } else if (node.name === "strong") {
          return {
            type: "text",
            bold: true,
            text: node.children
              .map((child) => (child.type === "text" ? child.content : ""))
              .join(""),
          };
        }
      } else if (node.type === "text") {
        return { text: node.content };
      }
      return null;
    };

    const result = ast.map(convertNode).flat(2).filter(Boolean);
    console.log(
      "Risultato convertito con lista e formattazione:",
      JSON.stringify(result, null, 2)
    );
    return { children: result };
  }

  // Conversione del contenuto

  const handleSubmit = async () => {
    const editorContent = editorRef.current.getContent();

    setFormData((prevData) => ({ ...prevData, sommario: editorContent }));
    console.log("FormData:", formData);

    let prezzo = formData.prezzo;

    // Assicurati che il prezzo sia un numero
    if (typeof prezzo === "string") {
      // Sostituisci la virgola con un punto se il numero è in formato italiano
      prezzo = prezzo.replace(",", ".");
    }

    // Converti in float
    prezzo = parseFloat(prezzo);

    // Controlla se il prezzo è un numero valido
    if (isNaN(prezzo)) {
      alert("Per favore inserisci un prezzo valido.");
      return;
    }

    // Arrotonda a 2 decimali
    prezzo = parseFloat(prezzo.toFixed(1));

    console.log("PROVA:", formData.dataPubblicazione);

    // becomes this AST:
    var ast = parse(editorContent);

    console.log("AST DA CONVERTIRE:", JSON.stringify(ast, null, 2));

    const richTextContent = JSON.parse(
      JSON.stringify(convertToHygraphRichText(ast))
    );
    console.log("RichTextContent (verificato):", richTextContent);

    // Risultato convertito

    try {
      //const assetId = "cm2wkgebuogsc07w9f354l8nh";
      const assetId = await handleUpload();

      if (!assetId) {
        return;
      }

      const variables = {
        numeroRivista: formData.numeroRivista,
        slugRivista: formData.slug_rivista,
        prezzo: prezzo,
        dataPubblicazione: formData.dataPubblicazione, // data fissa per esempio
        copertinaId: assetId,
        sommario: richTextContent,
      };

      const { data } = await createRivista({ variables });
      //console.log("Risposta dalla mutazione createRivista:", data);

      //console.log("Pubblicazione variabili:", data.createRiviste.id);

      await pubblicaRivista({
        variables: { idRivista: data.createRiviste.id },
      });
      //const idRivista = "cm2y2r1cmknm307uwi2udl266";
      // console.log(idRivista);

      //await pubblicaRivista({ variables: { idRivista } });

      //setMessage("Caricamento completato con successo!");
      setMessage("FINE");
    } catch (error) {
      console.error("Errore durante l'aggiornamento della rivista:", error);
    }

    return;
  };

  const handleCancelChanges = () => {
    setFormData({
      numeroRivista: "",
      prezzo: 0,
      slug_rivista: "",
      sommario: "",
    }); // Ripristina i dati originali
  };

  return (
    <div>
      <Header />
      <div className="flex min-h-screen">
        <Sidebar />
        <div className="flex flex-col flex-1 p-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="flex flex-col items-center mb-4">
              <div className="flex flex-col items-center w-full p-4 rounded bg-white shadow-lg">
                <h3 className="text-lg font-semibold mb-2">Carica Immagine</h3>
                <DragDrop file={file} setFile={setFile} />
                <input
                  type="file"
                  ref={fileInputRef}
                  onChange={(e) => handleFileChange(e.target.files[0])}
                  className="mt-4 mb-2 border p-2 w-full rounded-md hidden"
                />
                <button
                  type="button"
                  onClick={handleUpload}
                  className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                >
                  Carica
                </button>
              </div>
            </div>

            <div className="max-w-2xl mx-auto p-6 bg-white rounded-lg shadow-md">
              <h2 className="text-2xl font-semibold mb-4">Nuova Rivista</h2>
              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label className="block mb-2 text-sm font-medium text-gray-700">
                    Titolo:
                  </label>
                  <input
                    type="text"
                    name="numeroRivista"
                    value={formData.numeroRivista}
                    onChange={handleChange}
                    className="border p-2 w-full rounded-md"
                    placeholder="Inserisci titolo"
                  />
                </div>

                <div>
                  <label className="block mb-2 text-sm font-medium text-gray-700">
                    Prezzo:
                  </label>
                  <input
                    type="number"
                    name="prezzo"
                    value={formData.prezzo}
                    onChange={handleChange}
                    className="border p-2 w-full rounded-md"
                    placeholder="Inserisci prezzo"
                    step="0.01"
                    min="0"
                  />
                </div>

                <div>
                  <label className="block mb-2 text-sm font-medium text-gray-700">
                    URL Rivista:
                  </label>
                  <input
                    type="text"
                    name="slug_rivista"
                    value={formData.slug_rivista}
                    onChange={handleChange}
                    className="border p-2 w-full rounded-md"
                    placeholder="Inserisci URL rivista"
                  />
                </div>

                <div>
                  <label className="block mb-2 text-sm font-medium text-gray-700">
                    Data di Pubblicazione:
                  </label>
                  <input
                    type="date"
                    name="dataPubblicazione"
                    value={formData.dataPubblicazione}
                    onChange={handleChange}
                    className="border p-2 w-full rounded-md"
                  />
                </div>

                <div>
                  <label className="block mb-2 text-sm font-medium text-gray-700">
                    Sommario:
                  </label>
                  <Editor
                    apiKey="ubgl991rhweyb6n65o91ktl0n93d3b9d8twdoe4ji3ibxcvj"
                    onInit={(_evt, editor) => (editorRef.current = editor)}
                    initialValue={formData.sommario}
                    onEditorChange={(content) => setEditorContent(content)}
                    init={{
                      height: 500,
                      menubar: true,
                      plugins: [
                        "advlist",
                        "autolink",
                        "lists",
                        "link",
                        "image",
                        "charmap",
                        "preview",
                        "anchor",
                        "searchreplace",
                        "visualblocks",
                        "code",
                        "fullscreen",
                        "insertdatetime",
                        "media",
                        "table",
                        "code",
                        "help",
                        "wordcount",
                      ],
                      toolbar:
                        "fullscreen undo redo | blocks | bold italic forecolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help",
                      content_style:
                        "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                    }}
                  />
                </div>

                <div className="flex mt-4">
                  <button
                    type="button"
                    onClick={handleSubmit}
                    className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded mr-2"
                  >
                    Salva bozza
                  </button>
                  <button
                    type="button"
                    onClick={handleCancelChanges}
                    className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded"
                  >
                    Annulla modifiche
                  </button>
                </div>
              </form>

              {message && <p className="text-red-500 mt-4">{message}</p>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const NuovaRivista = ({}) => {
  return client ? (
    <ApolloProvider client={client}>
      <NuovaRivistaProva />
    </ApolloProvider>
  ) : (
    <p>Client non disponibile.</p>
  );
};

const ProductPage = () => {
  const { slug } = useParams();
  const [product, setProduct] = useState(null);
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [isLogged, setIsLogged] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const editorRef = useRef(null);
  const [originalData, setOriginalData] = useState(null); // Stato per memorizzare i dati originali
  const [formData, setFormData] = useState({
    numeroRivista: "",
    prezzo: 0,
    copertina: "",
    slugRivista: "",
    dataPubblicazione: "",
    sommario: "",
  });
  const [isPublished, setIsPublished] = useState(false);
  const location = useLocation();

  const [updateProductPrice] = useMutation(UPDATE_PRODUCT_PRICE);
  const [publishProduct] = useMutation(PUBLISH_PRODUCT);
  const [unpublishProduct] = useMutation(UNPUBLISH_RIVISTA);

  const { error: queryError, data } = useQuery(GET_PRODUCT_DATA, {
    variables: { slug },
    fetchPolicy: "no-cache", //
  });

  useEffect(() => {
    if (queryError) {
      console.error("Errore nella query draft:", queryError);
    } else if (data) {
      console.log("Dati DRAFT:", data.rivistes[0]);
    }
  }, [queryError, data]);

  const { error: publishedQueryError, data: publishedData } = useQuery(
    GET_PUBLISHED_PRODUCT,
    {
      variables: { slug },
      fetchPolicy: "no-cache", //
    }
  );

  useEffect(() => {
    if (publishedQueryError) {
      console.error("Errore nella query pubblicata:", publishedQueryError);
    } else if (
      publishedData &&
      publishedData.rivistes &&
      publishedData.rivistes[0]
    ) {
      console.log("Dati pubblicati:", publishedData.rivistes[0]);
      setIsPublished(true);
    } else {
      setIsPublished(false);
    }
  }, [publishedQueryError, publishedData]);

  useEffect(() => {
    if (!data || !data.rivistes || !data.rivistes[0]) return;
    const draftData = data.rivistes[0];

    if (
      !publishedData ||
      !publishedData.rivistes ||
      !publishedData.rivistes[0]
    ) {
      setMessage("Il prodotto non è stato pubblicato.");
      setIsPublished(false);
    } else {
      const publishedDate = publishedData.rivistes[0].publishedAt;
      const draftDate = draftData.updatedAt;

      if (draftDate < publishedDate) {
        setMessage("Il prodotto è stato pubblicato.");
        setIsPublished(true);
      } else {
        setMessage("Il prodotto non è stato pubblicato.");
        setIsPublished(false);
      }
    }
  }, [data, publishedData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async () => {
    let prezzo = formData.prezzo;

    // Assicurati che il prezzo sia un numero
    if (typeof prezzo === "string") {
      // Sostituisci la virgola con un punto se il numero è in formato italiano
      prezzo = prezzo.replace(",", ".");
    }

    // Converti in float
    prezzo = parseFloat(prezzo);

    // Controlla se il prezzo è un numero valido
    if (isNaN(prezzo)) {
      alert("Per favore inserisci un prezzo valido.");
      return;
    }

    // Arrotonda a 2 decimali
    prezzo = parseFloat(prezzo.toFixed(1));

    const editorContent = log();

    var ast = parse(editorContent);

    console.log("AST DA CONVERTIRE:", JSON.stringify(ast, null, 2));

    const richTextContent = JSON.parse(
      JSON.stringify(convertToHygraphRichText(ast))
    );

    console.log("RICHTEXT CONVERTITO:", richTextContent);

    try {
      console.log("Salvataggio in corso...");
      setTimeout(() => {
        console.log(formData.slugRivista);
      }, 2000);

      await updateProductPrice({
        variables: {
          id: product.id,
          prezzo: prezzo,
          numeroRivista: formData.numeroRivista,
          slug_rivista: formData.slugRivista,
          dataPubblicazione: formData.dataPubblicazione,
          sommario: richTextContent,
        },
      });
      console.log("Prezzo aggiornato con successo!");
      window.location.reload();
    } catch (e) {
      console.error(e);
      console.log("Errore durante l'aggiornamento del prezzo");
    }
  };

  const handlePublishProduct = async () => {
    try {
      await publishProduct({
        variables: {
          id: product.id,
        },
      });
      window.location.reload();
      console.log("Prodotto pubblicato con successo!");
    } catch (e) {
      console.error(e);
      console.log("Errore durante la pubblicazione del prodotto");
    }
  };

  const handleUnpublish = async () => {
    try {
      await unpublishProduct({
        variables: {
          idRivista: product.id,
        },
      });
      window.location.reload();
      console.log("Annullata pubblicazione con successo!");
    } catch (e) {
      console.error(e);
      console.log(
        "Errore durante l'annullazione della pubblicazione del prodotto"
      );
    }
  };

  const handleCancelChanges = () => {
    setFormData(originalData); // Ripristina i dati originali
    setIsEditing(false);
  };

  useEffect(() => {
    if (data) {
      const productData = data.rivistes[0];
      console.log(productData);
      setProduct(productData);
      setOriginalData({
        numeroRivista: productData.numeroRivista,
        prezzo: productData.prezzo,
        copertina: productData.copertina.url,
        slugRivista: productData.slugRivista,
        dataPubblicazione: productData.dataPubblicazione,
        sommario: productData.sommario.html,
      });
      setFormData({
        numeroRivista: productData.numeroRivista,
        prezzo: productData.prezzo,
        copertina: productData.copertina.url,
        slugRivista: productData.slugRivista,
        dataPubblicazione: productData.dataPubblicazione,
        sommario: productData.sommario.html,
      });
      setIsLoading(false);
    }
  }, [data]);

  const log = () => {
    if (editorRef.current) {
      return editorRef.current.getContent();
    }
    return null;
  };

  if (queryError) {
    return <NotFound />;
  }

  if (!isLogged) {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  if (isLoading) {
    return (
      <div className="flex flex-col min-h-screen">
        <Header />
        <div className="flex flex-col justify-center items-center flex-grow">
          <Skeleton height="100%" />
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div>
      <Header />
      <div className="flex min-h-screen">
        {/* Sidebar */}
        <Sidebar />
        <div className="flex flex-col flex-1 p-12">
          {" "}
          {/* Flex-1 per espandere il contenuto */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="flex justify-center mb-4">
              {" "}
              {/* Centra l'immagine */}
              <img
                src={product.copertina.url}
                alt={product.copertina.fileName}
                className="w-full h-auto max-w-full sm:max-w-sm md:max-w-md lg:max-w-lg"
                style={{
                  maxWidth: "400px",
                  maxHeight: "500px",
                  minHeight: "90px",
                  minWidth: "90px",
                }}
              />
            </div>
            <div className="text-left">
              <form onSubmit={handleSubmit}>
                {isEditing ? (
                  <>
                    <input
                      type="text"
                      name="numeroRivista"
                      value={formData.numeroRivista}
                      onChange={handleChange}
                      className="border mb-4 p-2 w-full"
                      placeholder="Titolo"
                    />
                    <input
                      type="number"
                      name="prezzo"
                      value={formData.prezzo}
                      onChange={handleChange}
                      className="border mb-4 p-2 w-full"
                      placeholder="Prezzo"
                      step="0.01"
                      min="0"
                    />
                    <input
                      type="text"
                      name="copertina"
                      value={formData.copertina}
                      onChange={handleChange}
                      className="border mb-4 p-2 w-full"
                      placeholder="URL Copertina"
                    />

                    <div>
                      <label className="block mb-2 text-sm font-medium text-gray-700">
                        URL Rivista:
                      </label>
                      <input
                        type="text"
                        name="slugRivista"
                        value={formData.slugRivista}
                        onChange={handleChange}
                        className="border p-2 w-full rounded-md"
                        placeholder="Inserisci URL rivista"
                      />
                    </div>

                    <div>
                      <label className="block mb-2 text-sm font-medium text-gray-700">
                        Data di Pubblicazione:
                      </label>
                      <input
                        type="date"
                        name="dataPubblicazione"
                        value={formData.dataPubblicazione}
                        onChange={handleChange}
                        className="border p-2 w-full rounded-md"
                      />
                    </div>
                    <Editor
                      apiKey="ubgl991rhweyb6n65o91ktl0n93d3b9d8twdoe4ji3ibxcvj"
                      onInit={(_evt, editor) => (editorRef.current = editor)}
                      initialValue={formData.sommario}
                      init={{
                        height: 500,
                        menubar: true,
                        plugins: [
                          "advlist",
                          "autolink",
                          "lists",
                          "link",
                          "image",
                          "charmap",
                          "preview",
                          "anchor",
                          "searchreplace",
                          "visualblocks",
                          "code",
                          "fullscreen",
                          "insertdatetime",
                          "media",
                          "table",
                          "code",
                          "help",
                          "wordcount",
                        ],
                        toolbar:
                          "fullscreen undo redo | blocks | " +
                          "bold italic forecolor | alignleft aligncenter " +
                          "alignright alignjustify | bullist numlist outdent indent | " +
                          "removeformat | help",
                        content_style:
                          "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                      }}
                    />
                    <div className="flex mt-4">
                      {" "}
                      {/* Allinea i bottoni */}
                      <button
                        type="button"
                        onClick={handleSubmit}
                        className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded mr-2"
                      >
                        Salva bozza
                      </button>
                      <button
                        type="button"
                        onClick={handleCancelChanges}
                        className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded"
                      >
                        Annulla modifiche
                      </button>
                    </div>
                  </>
                ) : (
                  <>
                    {/* Display the message */}
                    <div className="my-4 p-4 border border-gray-300 rounded-lg bg-gray-50 shadow-sm flex items-center w-auto">
                      {isPublished ? (
                        <>
                          <AiOutlineCheckCircle className="text-green-500 text-2xl mr-3" />
                          <p className="text-lg font-medium text-green-500">
                            {message}
                          </p>
                        </>
                      ) : (
                        <>
                          <CiCircleAlert className="text-blue-500 text-2xl mr-3" />
                          <p className="text-lg font-medium text-blue-500">
                            {message}
                          </p>
                        </>
                      )}
                    </div>

                    <h2 className="text-3xl font-bold mb-4">
                      {product.numeroRivista}
                    </h2>
                    <p className="text-2xl mb-4">
                      Prezzo: €{product.prezzo.toFixed(2)}
                    </p>
                    <div>
                      <label className="block mb-2 text-sm font-medium text-gray-700">
                        URL Rivista:
                      </label>
                      <p>{formData.slugRivista}</p>
                    </div>

                    <div>
                      <label className="block mb-2 text-sm font-medium text-gray-700">
                        Data di Pubblicazione:
                      </label>
                      <p>{formData.dataPubblicazione}</p>
                    </div>
                    <div className="mt-8 prose">
                      <label className="block mb-2 text-sm font-medium text-gray-700">
                        Sommario:
                      </label>
                      <RichText content={product.sommario.raw} />
                    </div>
                  </>
                )}
              </form>
              {!isEditing && (
                <div className="flex mt-4">
                  {" "}
                  {/* Allinea i bottoni */}
                  <button
                    onClick={() => setIsEditing(true)}
                    className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mr-2"
                  >
                    Modifica contenuti
                  </button>
                  <button
                    onClick={() => {
                      handlePublishProduct();
                      setIsEditing(false);
                    }}
                    className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded mr-2"
                  >
                    Pubblica contenuti
                  </button>
                  <button
                    onClick={() => {
                      handleUnpublish();
                      setIsEditing(false);
                    }}
                    className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded "
                  >
                    Annulla pubblicazione
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

const App = () => (
  <ApolloProvider client={client}>
    <ProductPage />
  </ApolloProvider>
);

export default App;
